/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { useEffect, useState } from 'react';
import {
    object, string, array,
} from 'prop-types';
import { useUIDSeed } from 'react-uid';
import LazyLoad from 'react-lazyload';
import ReactHtmlParser from 'react-html-parser';
import Paper from '@material-ui/core/Paper';

const ProductImageUIMobileBlock = ({
    classes,
    productName,
    name,
    path,
    snipe,
    snipeImagePath,
    additionalImages,
    productNameDisplay,
    brand,
}) => {
    const seed = useUIDSeed();
    const [sliderCount, setSliderCount] = useState(0);
    const [sliderIndex, setSliderIndex] = useState(0);
    const slContainer = React.createRef();
    const sliderIndexMatrix = [];
    useEffect(() => {
        if (slContainer?.current?.children) {
            setSliderCount(slContainer.current.children.length);
            [...Array(sliderCount)].forEach((val, index) => {
                sliderIndexMatrix.push(slContainer.current.offsetWidth * index);
            });
        }
    });
    /**
     * Capture container scroll event
     * @param {object} e - event
     */
    const handleScroll = (e) => {
        sliderIndexMatrix.forEach((value, index) => {
            if (e.target.scrollLeft >= value) {
                setSliderIndex(index);
            }
        });
    };

    // TODO Chnage to productNameDisplay === "Overlay", Once the value is updated on 18F
    const isProductNameOnOverlay = productNameDisplay !== 'Normal';
    return (
        <>
            <Paper className={classes.root}>
                <div className={isProductNameOnOverlay === true ? classes.productNameContainer : classes.productImageSliderContainer}>
                    {sliderCount > 1 && (
                        <div className={classes.sliderDotsContainer}>
                            {[...Array(sliderCount)].map((e, index) => (
                                <div className={index === sliderIndex ? classes.dotsActive : classes.dotsInactive} />
                            ))}
                        </div>
                    )}
                </div>

                <div className={classes.sliderContainer} ref={slContainer} onScroll={handleScroll}>
                    <img className={classes.slide} alt={productName} src={`${path}${name}x.jpg`} />
                    {additionalImages?.map((img) => (
                        <LazyLoad key={seed(img)}>
                            <img className={classes.slide} alt={productName} src={`${path}${img}x.jpg`} />
                        </LazyLoad>
                    ))}
                </div>
                {snipe && <img className={classes.snipe} alt={snipe} src={`${snipeImagePath}${snipe}_z.gif`} />}
            </Paper>
            {(isProductNameOnOverlay === true && brand.code !== 'PLA') ? <div className={classes.productName}>{ReactHtmlParser(productName)}</div> : null}
            {(!isProductNameOnOverlay && brand.code !== 'PLA') ? <div className={classes.productNameforNormal}>{productName}</div> : null}
        </>
    );
};

ProductImageUIMobileBlock.propTypes = {
    classes: object.isRequired,
    productName: string.isRequired,
    path: string.isRequired,
    snipe: string.isRequired,
    name: string.isRequired,
    snipeImagePath: string.isRequired,
    additionalImages: array.isRequired,
    productNameDisplay: string.isRequired,
    brand: object,
};

ProductImageUIMobileBlock.defaultProps = {
    brand: {},
};

export default ProductImageUIMobileBlock;
